import React from "react";
import { withAppContext } from "containers/HOC";
import ActionLink from "./ActionLink";

class Confirm extends React.Component {
    _closeOnEscape = (e) => {
        if (e.keyCode === 27) {
            this._cancel(e);
        }
    };

    _cancel = (e) => {
        e.preventDefault();
        this.props.closeModal();
    };

    _confirm = (e) => {
        e.preventDefault();
        this.props.modal.onConfirm();
        if (this.props.modal.props.closeOnConfirm) this.props.closeModal();
    };

    componentDidMount() {
        document.addEventListener("keydown", this._closeOnEscape);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this._closeOnEscape);
    }

    render() {
        const { isSaving, modalError } = this.props;
        const { undoMessage = "This action cannot be undone." } = this.props.modal.props;
        return (
            <div className={`Modal_wrapper u-z-top ${isSaving ? "waiting" : ""}`}>
                <div className="Modal Modal--notification">
                    <ActionLink onClick={this._cancel} className="Modal-close">
                        <i className="icon icon-cross" />
                    </ActionLink>
                    <div className="Modal-body u-pl-lg u-pr-lg">
                        {modalError && (
                            <div className="Alert Alert--error">
                                <i className="icon icon-alert" id="login-errormsg" />
                                {modalError}
                            </div>
                        )}
                        <i className="icon icon-alert icon--lg icon--confirm" />
                        <h2>{this.props.modal.props.message}</h2>
                        <p>{undoMessage}</p>
                    </div>
                    <div className="Modal-footer">
                        <button id="cancel-button" onClick={this._cancel} className="Button Button--primary" type="button" name="cancel-button">
                            No
                        </button>
                        <button id="confirm-button" disabled={isSaving} className="Button Button--secondary" onClick={this._confirm}>
                            Yes
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default withAppContext(Confirm);
